export default "__VITE_ASSET__DNHEnxpa__"